<template>
    <div class="main tw-flex tw-items-center tw-flex-col tw-justify-center tw-h-fit">
        <div
            class="container tw-relative tw-bg-white md:tw-rounded-lg tw-p-3 lg:tw-px-24 tw-pb-20"
        >
            <loading-spinner
                    v-if="pending"
                    :is-overlay="true"
                    size="50"
            />
            <router-view
                v-if="!pending"
            />
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
import LoadingSpinner from './components/baseComponents/LoadingSpinner.vue';

    export default {
  components: { LoadingSpinner },
        data: () => ({
        }),
        computed: {
            ...mapGetters({
                tour: 'tour/route',
                country: 'tour/country',
                inquiry: 'tour/inquiry',
                pending: 'tour/pending',
            }),
        },
        created () {
            const { tour, country } = this.$options.parent
            if(tour) {
                this.loadTour(tour)
            } else if(country) {
                this.loadCountry(country)
            }
        },
        watch: {
        },
        methods: {
            ...mapActions({
                loadTour: 'tour/loadTour',
                loadCountry: 'tour/loadCountry',
            }),
        },
    }
</script>


<style scoped>
    .main {
        background-size: cover;
        max-width: 100% !important;
    }

    .container {
        width: 810px;
        max-width: 100%;
        min-height: 560px;
        height: fit-content;
    }
</style>